import { useReactFlow } from '@xyflow/react'
import { useCallback, useEffect, useRef } from 'react'

import { ConferenceRoomNodeData } from '../../../converters/shared/reactFlowTypes'

/**
 * Hook for Conference Room node functionality.
 * Handles conference room selection.
 */
export const useConferenceRoomNode = (
  id: string,
  data: ConferenceRoomNodeData,
) => {
  const { updateNodeData } = useReactFlow()
  const dataRef = useRef(data)

  // Keep dataRef in sync with data
  useEffect(() => {
    dataRef.current = data
  }, [data])

  const currentConferenceRoomId = data.conferenceRoomId || ''

  const handleConferenceRoomChange = useCallback(
    (conferenceRoomId: string | undefined) => {
      updateNodeData(id, {
        ...dataRef.current,
        conferenceRoomId,
      })
    },
    [id, updateNodeData],
  )

  return {
    currentConferenceRoomId,
    handleConferenceRoomChange,
    hasData: !!currentConferenceRoomId,
  }
}
